import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

import TrackCommentsDisplay from "./TrackCommentsDisplay";
import TrackMedia from "../../Components/library/TrackMedia";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSettings } from "~/Context/SettingsContext";
import ArtistName from "../../Components/Elements/ArtistName";
import TrackGenre from "../../Components/Elements/TrackGenre";
import ChimneyName from "../../Components/Elements/ChimneyName";
import TrackFavorite from "../../Components/Icons/TrackFavorite";
import JukeboxPlayTrack from "../../Components/Elements/Global/JukeboxPlayTrack";
import { useUser } from "~/Context/userContext";
import useReplaceHref from "~/utils/useReplaceHref";
import TrackAddPlaylist from "~/Components/Icons/TrackAddPlaylist";
import { getPlaylistsForTracks } from "~/api/getCustomPlaylists";
// import TrackComments from "../../Components/Icons/TrackComments";

import "./css/TrackHome.less";

const TrackHome = (props) => {
  const { settings } = useSettings();
  const { tracks: todaysTracks, loading, daysAgo } = props;
  const { state: userState } = useUser();
  useReplaceHref();

  const [loadingLists, setLoadingLists] = useState(true);
  const [playlists, setPlaylists] = useState([]);

  const load = async () => {
    if (todaysTracks && todaysTracks.length) {
      // console.log("🚀 ~ file: TrackHome.js:38 ~ load ~ todaysTracks:", todaysTracks);
      const trackIds = todaysTracks.map((t) => t.id).join(",");
      // console.log("🚀 ~ file: TrackHome.js:38 ~ load ~ trackIds:", trackIds);
      const resp = await getPlaylistsForTracks(axios, trackIds);
      // console.log("🚀 ~ file: RecentPlaylists.js:14 ~ load ~ resp:", resp);
      setPlaylists(resp.data.playlists);
      setLoadingLists(false);
    }
  };
  useEffect(() => {
    load();
  }, [todaysTracks]);

  function createMarkup(text) {
    return { __html: text };
  }

  if (loading) {
    return (
      <Col xs={12}>
        <Spinner animation="border" size="sm" /> Loading...
      </Col>
    );
  }
  if (!loading && todaysTracks.length === 0) {
    return (
      <div className="home-no-tracks-message">
        No tracks{" "}
        {daysAgo > 0 ? (
          "were posted on that day."
        ) : (
          <React.Fragment>
            have been posted today. <Link to={`/rewind/1`}>Check yesterday's tracks</Link> or previous tracks below.
          </React.Fragment>
        )}
      </div>
    );
  }

  const layoutCols = settings.trackUiCols;
  const tracks = todaysTracks.map((track) => (
    <Col
      xs={12}
      sm={{ span: layoutCols ? 6 : 12 }}
      md={{ span: layoutCols ? 4 : 12 }}
      lg={{ span: layoutCols ? 3 : 12 }}
      key={track.id}
      className={"track-totd-box " + (settings.trackUiCols ? "totd-layout-cols" : "totd-layout-rows")}
    >
      {/* div needed for comment form placement */}
      <div className="track-totd-wrapper">
        <div>
          <ChimneyName user={track.user} />
        </div>
        <div className="totd-wrapper">
          <div className="totd-title">
            <Row>
              <Col xs={12} sm={12} md={{ span: layoutCols ? 12 : 5 }}>
                <span className="sprite sprite-track" />
                <div className="totd-row">
                  <Link to={`/${track.id}`}>
                    <span dangerouslySetInnerHTML={createMarkup(track.title)} />
                  </Link>
                </div>

                {track.artist && (
                  <div className="totd-from">
                    <span className="sprite sprite-artist" />
                    <div className="totd-row">
                      <ArtistName track={track} />
                    </div>
                  </div>
                )}

                {track.album && (
                  <div className="totd-from">
                    <span className="sprite sprite-from" />
                    <div className="totd-row">{track.album}</div>
                  </div>
                )}

                <div className="totd-meta">
                  <span className="sprite sprite-soundsbestwhen" />
                  <div className="totd-row">{track.sbw}</div>
                </div>

                <div className="totd-fileunder">
                  <span className="sprite sprite-fileunder" />
                  <div className="totd-row">
                    <TrackGenre track={track} />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={{ span: layoutCols ? 12 : 7 }}>
                <div className="totd-track">
                  <span className="sprite sprite-comment" />
                  <div className="totd-row">
                    {track.dc_promo && (
                      <div>
                        <Link to="/promo-tracks">
                          <img
                            src="//www.dreamchimney.com/tracks/images/dc_promo_tracks.png"
                            alt="DC Promo Tracks"
                            className="img-responsive center-block promo-tracks-icon"
                            id="dc-promo-tracks-logo"
                          />
                        </Link>
                      </div>
                    )}

                    {/* <track-edit track="track" withtext="false" /> */}
                    <div className="track-comment" dangerouslySetInnerHTML={createMarkup(track.comment)} />

                    {track.media_id && settings.playInJukebox ? (
                      <JukeboxPlayTrack track={track} layoutCols={layoutCols} />
                    ) : (
                      <TrackMedia track={track} layout={settings.trackUiCols ? "thin" : "wide"} />
                    )}
                    <div className="edit-track">
                      {userState.user.dir === track.chimdir && (
                        <div className="footer-item footer-track-edit-icon">
                          <Link to={`/${track.id}/edit`} title="Edit this track">
                            Edit <FontAwesomeIcon icon={["fas", "edit"]} style={{ marginLeft: "6px" }} />
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={{ span: layoutCols ? 12 : 5 }}>
                <div>
                  <div className="totd-bottom">
                    {/* <inline-comment trackid="track.id" replies="track.replies" /> */}
                    {/* <TrackComments numReplies={track.replies.length} /> */}
                    <TrackFavorite track={track} />
                    <div className="icon icon-permalink">
                      <Link to={`/${track.id}`} title="Track detail and comments">
                        <FontAwesomeIcon icon="compact-disc" className="compact-disc" />
                      </Link>
                    </div>
                    <div className="icon icon-playlist">
                      <TrackAddPlaylist track={track} />
                    </div>
                  </div>
                  {track.rerule > 0 && (
                    <div className="totd-rerule">
                      Re-rule <Link to={`/${track.rerule}`}>originally posted</Link> by {track.reruleChim.full_name} on{" "}
                      {track.reruleChim.rerule_date}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div>
          <TrackCommentsDisplay layoutCols={layoutCols} track={track} playlists={playlists} />
        </div>
      </div>
    </Col>
  ));
  return <React.Fragment>{tracks}</React.Fragment>;
};

export default TrackHome;
